<template>
    <div class="list-checkbox">
        <input type="text" class="form-control" placeholder="Cari.." @input="searchData" />
        <ul class="list-group">
            <li class="list-group-item" v-if="isAll">
                <input class="form-check-input me-1" type="checkbox" value="all" aria-label="..." @input="selectAll">
                Semua
            </li>
            <li class="list-group-item" v-for="item in listData" :key="item[tracked]">
                <input class="form-check-input me-1" type="checkbox" :value="item[tracked]" v-model="input" aria-label="..." @input="handleInput">
                {{item[label]}}
            </li>
            <li class="list-group-item" v-if="listData.length == 0">
                Tidak Ada Data
            </li>
        </ul>
    </div>
</template>

<style>
.list-group {
    max-height: 300px;
    overflow-y: auto;
}
</style>

<script>
export default {
    props: {
        value: {
            type: Array,
            required: true
        },
        data: {
            type: Array,
            required: false
        },
        tracked: {
            type: String,
            required: false,
            default: 'id'
        },
        label: {
            type: String,
            required: false,
            default: 'name'
        }
    },
    data() {
        return {
            input: [],
            listData: this.data,
            isAll: true
        }
    },
    mounted() {
        this.$emit('input', []);
        setTimeout(() => {
            this.listData = this.data;
        }, 800);
    },
    methods: {
        handleInput(event) {
            if(event.target.checked) {
                this.input.push(parseInt(event.target.value))
            }else {
                var index = this.input.indexOf(parseInt(event.target.value));
                if (index !== -1) {
                    this.input.splice(index, 1);
                }
            }
            this.$emit('input', this.input)
        },

        searchData(event) {
            const value = event.target.value.toLowerCase();
            if(value == ''){
                this.isAll = true;
            }else{
                this.isAll = false;
            }

            var self = this;
            var filtered = this.data.filter(function(item) {
                return item[self.label].toLowerCase().includes(value);
            });
            
            this.listData = filtered;
        },

        selectAll(event) {
            const checked = event.target.checked;
            if(checked) {
                this.input = this.listData.map(item => item[this.tracked])
            }else {
                this.input = [];
            }
        }
    }
};
</script>